module.exports = __webpack_public_path__ + "img/accountant.becd4426.png";